// @spec BCP-STR-008
// Layout route for BCP plan detail and its child routes (edit, review)

import { createFileRoute, Outlet } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/plans/$planId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.planDetails'),
  }),
  component: PlanDetailLayout,
});

function PlanDetailLayout() {
  return <Outlet />;
}
